export const PROJECT_TYPES = 'ihut,concept_test';
